import {post} from "@/utils/request.ts";

export default class apiYjIndex {
    static module : string  = 'yj_index'
    static async baseInfo() {
        return post(`/home/yj_index/baseInfo`)
    }

    static async index(){
        return post(`/home/yj_index/index`)
    }
}
